import "./App.css";
import Main from "./Component/Main";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Privacy from "./Component/Privacy";
import ProductDetail from "./Component/ProductDetail";
import CartPage from "./Component/CartPage";
import CheckOut from "./Component/CheckOut";
import { CartProvider } from "./Component/CartContext";
import PaySuccess from "./Component/SuccessPay";
import Terms from "./Component/Terms";
import Shop from "./Component/Shop";
import Contact from "./Component/Contact";
import Returns from "./Component/Returns";
import About from "./Component/About";
import Header from "./Component/Header";
import Footer from "./Component/Footer";
import Delivery from "./Component/Delivery";
import FAQs from "./Component/FAQs";
import Cookies from "./Component/Cookies";
import Policies from "./Component/Policies";
import AdditionalPolicy from "./Component/AdditionalPolicy";

function App() {
  return (
    <CartProvider>
      <Router
        future={{
          v7_relativeSplatPath: true,
          v7_startTransition: true,
        }}
      >
        <a className="skip-link" href="#main-content">
          Skip to content
        </a>
        <Header />
        <div id="main-content" tabIndex={-1}>
          <Routes>
            <Route path="/about" element={<About />} />
            <Route path="/shipping" element={<Delivery />} />
            <Route path="/" element={<Main />} />
            <Route path="/returns" element={<Returns />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/faqs" element={<FAQs />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/policies" element={<Policies />} />
            <Route path="/payments" element={<AdditionalPolicy policyKey="payments" />} />
            <Route path="/orders" element={<AdditionalPolicy policyKey="orders" />} />
            <Route path="/product-safety" element={<AdditionalPolicy policyKey="product-safety" />} />
            <Route path="/quality-guarantee" element={<AdditionalPolicy policyKey="quality-guarantee" />} />
            <Route path="/promotions" element={<AdditionalPolicy policyKey="promotions" />} />
            <Route path="/data-rights" element={<AdditionalPolicy policyKey="data-rights" />} />
            <Route path="/communications" element={<AdditionalPolicy policyKey="communications" />} />
            <Route path="/security" element={<AdditionalPolicy policyKey="security" />} />
            <Route path="/accessibility" element={<AdditionalPolicy policyKey="accessibility" />} />
            <Route path="/intellectual-property" element={<AdditionalPolicy policyKey="intellectual-property" />} />
            <Route path="/sustainability" element={<AdditionalPolicy policyKey="sustainability" />} />
            <Route path="/complaints" element={<AdditionalPolicy policyKey="complaints" />} />
            <Route path="/shopDetails/:id" element={<ProductDetail />} />
            <Route path="/cartpage" element={<CartPage />} />
            <Route path="/checkout" element={<CheckOut />} />
            <Route path="/payment" element={<PaySuccess />} />
            <Route path="/paysuccess" element={<PaySuccess />} />
          </Routes>
        </div>
        <Footer />
      </Router>
    </CartProvider>
  );
}

export default App;
